import { ErrorHandler, inject, Injectable } from '@angular/core';
import { FehlerService } from './fehler.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandler implements ErrorHandler {
  private fehlerService = inject(FehlerService);
  constructor() {}

  handleError(error: any) {
    if (error instanceof ApiError) {
      // API-Fehler → ignorieren
      return;
    }

    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
    }

    //this.fehlerService.FehlerReport(error);
  }
}

export class ApiError extends Error {
  constructor(
    public override message: string,
    public status?: number,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}
